import 'regenerator-runtime/runtime'

import "/_components/cookiebanner/cookiebanner.js";
import "/_components/countup/countup.ts";
import "/_components/crossfader/crossfader.ts";
import "/_components/hero/hero.ts";
import "/_components/hotspot/hotspot.ts";
import "/_components/navigation/navigation.ts";
import "/_components/scroll-pin/scroll-pin.ts";
import "/_components/scroll-reveal/scroll-reveal.ts";
import "/_components/scroll-parallax/scroll-parallax.ts";
import "/_components/showcase/showcase.ts";
import "/_components/slider/slider.ts";
import "/_components/lottie/lottie.ts";
import "/_components/timeline/timeline";
import "/_components/wipe-reveal/wipe-reveal";
import "/_atoms/animation/animation.ts";
